<template>
  <div class="staff-grid4-list-wrap">
    <div class="staff-grid4-list">
      <StaffGrid4PeopleItem
        v-for="person in visiblePeople"
        :key="person.id"
        :people_item="person"
        :show-qualification-category="showQualificationCategory"
        :show-department="showDepartment"
        :open-photo-on-click="openPhotoOnClick"
        :show-detail-link="showDetailLink"
        :detail-link="person.detailLink || defaultDetailLink"
        @open-photo="$emit('open-photo', $event)"
      />
    </div>
    <div v-if="canShowMore" class="staff-grid4-list__more-wrap">
      <button
        type="button"
        class="staff-grid4-list__more-btn"
        @click="showMore"
      >
        Показать ещё
      </button>
    </div>
  </div>
</template>

<script>
import StaffGrid4PeopleItem from "@/components/People/StaffGrid4PeopleItem.vue";

export default {
  name: "StaffGrid4PeopleList",
  components: { StaffGrid4PeopleItem },
  props: {
    people_list: {
      type: Array,
      required: true,
    },
    showQualificationCategory: {
      type: Boolean,
      default: true,
    },
    showDepartment: {
      type: Boolean,
      default: false,
    },
    openPhotoOnClick: {
      type: Boolean,
      default: false,
    },
    showDetailLink: {
      type: Boolean,
      default: false,
    },
    defaultDetailLink: {
      type: String,
      default: '/about/specialists',
    },
    pageSize: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      visibleCount: this.pageSize > 0 ? this.pageSize : 0,
    };
  },
  computed: {
    visiblePeople() {
      if (!this.pageSize || this.pageSize <= 0) {
        return this.people_list;
      }
      return (this.people_list || []).slice(0, this.visibleCount);
    },
    canShowMore() {
      if (!this.pageSize || this.pageSize <= 0) {
        return false;
      }
      return this.visibleCount < (this.people_list || []).length;
    },
    peopleListSignature() {
      const list = this.people_list || [];
      const first = list[0];
      const last = list[list.length - 1];
      return [
        list.length,
        first && first.id,
        last && last.id,
      ].join(':');
    },
  },
  watch: {
    peopleListSignature() {
      this.resetVisible();
    },
    pageSize() {
      this.resetVisible();
    },
  },
  methods: {
    resetVisible() {
      this.visibleCount = this.pageSize > 0 ? this.pageSize : 0;
    },
    showMore() {
      const total = (this.people_list || []).length;
      this.visibleCount = Math.min(this.visibleCount + this.pageSize, total);
    },
  },
};
</script>

<style scoped lang="scss">
$green: #66cc66;

.staff-grid4-list-wrap {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.staff-grid4-list {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  overflow: hidden;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }

  @media (max-width: 767.98px) {
    grid-template-columns: 1fr;
    gap: 10px;
  }
}

.staff-grid4-list__more-wrap {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}

.staff-grid4-list__more-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 28px;
  border: 1px solid $green;
  border-radius: 999px;
  background: transparent;
  font-family: "Circe", sans-serif;
  font-size: 15px;
  color: $green;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(102, 204, 102, 0.06);
  }
}
</style>
